import React, { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    MobileIcon,
    ModalHeader,
} from "../Styles/InputStyles";
import { MdClose } from "react-icons/md";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";

// Step 1 Validation Schema
const stepOneSchema = Yup.object().shape({
    landlordName: Yup.string()
        .matches(/^[A-Za-z0-9. - ]+$/, "Only alphabets, numbers, spaces and hyphens are allowed")
        .min(3, "Landlord name must be at least 3 characters long")
        .required("Landlord name is required"),
    mobile: Yup.string()
        .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits")
        .required("Mobile number is required"),
    email: Yup.string()
        .matches(
            /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
            "Enter a valid email address"
        )
        .nullable()
        .notRequired()
        .transform((value) => (value === "" ? null : value)),

});


const AddLandlord = ({
    addLandlordMutate,
    addLandlordLoading,
    handleClose,
    selectedData,
}) => {

    const [formData, setFormData] = useState({
        landlordName: "",
        mobile: "",
        email: "",
        address: "",
    });

    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleSubmit = (values) => {
        addLandlordMutate({
            name: values.landlordName,
            mobile: values.mobile,
            email: values.email,
        });
    };

    return (
        <Container
            style={{
                height: `${height}px`,
                overflow: "auto",
                WebkitOverflowScrolling: "touch",
            }}
        >
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">
                    {"Add Landlord Details"}
                </h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>
            <div className="px-6 h-full flex flex-col justify-between">
                <Formik
                    initialValues={formData}
                    onSubmit={handleSubmit}
                    validationSchema={stepOneSchema}
                    enableReinitialize
                >
                    {({
                        values,
                        setFieldValue,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                    }) => (
                        <Form>
                            <ScrollableContent className="max-h-[calc(100dvh-150px)]">
                                <Wrapper>
                                    <InputGroup>
                                        <Label htmlFor="landlordName">Landlord Name *</Label>
                                        <FieldWrappers>
                                            <Field
                                                type="text"
                                                name="landlordName"
                                                id="landlordName"
                                                autoComplete="off"
                                                placeholder="Enter landlord name"
                                            />
                                        </FieldWrappers>
                                        {errors.landlordName && touched.landlordName && (
                                            <ErrorMessage>{errors.landlordName}</ErrorMessage>
                                        )}
                                    </InputGroup>

                                    {/* Mobile Number */}
                                    <InputGroup>
                                        <Label htmlFor="mobile">Mobile Number *</Label>
                                        <FieldWrappers>
                                            <MobileIcon />
                                            <Field
                                                type="text"
                                                name="mobile"
                                                id="mobile"
                                                autoComplete="off"
                                                maxLength={10}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d{0,10}$/.test(value)) {
                                                        setFieldValue("mobile", value);
                                                    }
                                                }}
                                                placeholder="Enter 10-digit mobile number"
                                                className="w-full pl-5"
                                            />
                                        </FieldWrappers>
                                        {errors.mobile && touched.mobile && (
                                            <ErrorMessage>{errors.mobile}</ErrorMessage>
                                        )}
                                    </InputGroup>

                                    <InputGroup>
                                        <Label htmlFor="email">Email</Label>
                                        <FieldWrappers>
                                            <Field
                                                type="email"
                                                name="email"
                                                id="email"
                                                autoComplete="off"
                                                placeholder="Enter email address (optional)"
                                            />
                                        </FieldWrappers>
                                        {errors.email && touched.email && (
                                            <ErrorMessage>{errors.email}</ErrorMessage>
                                        )}
                                    </InputGroup>

                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <SideCancelBtn type="button" onClick={handleClose}>
                                    Cancel
                                </SideCancelBtn>
                                <SubmitBtn type="submit">
                                    {addLandlordLoading ? "Submitting..." : "Submit"}
                                </SubmitBtn>
                            </ActionSection>
                        </Form>
                    )}
                </Formik>
            </div>
        </Container>
    );
};

// Styled components
const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
const ErrorMessage = tw.div`text-red-500 text-xs mt-1`;

export default AddLandlord;